import {ReactNode} from 'react'

import classNames from 'classnames/bind'

import Styles from './BadgeRoundBox.module.scss'

const cx = classNames.bind(Styles)

export interface BadgeRoundBoxProps {
    color?:
        | 'red500'
        | 'line-green500'
        | 'line-green500-w' // 배경색 흰색 버전
        | 'line-red500-w' // 배경색 흰색 버전
        | 'red200'
        | 'green100'
        | 'green200'
        | 'gray150'
        | 'gray600'
        | 'green500'
        | 'line-gray600'
        | 'blue200'
        | 'yellow200'
    size?: 'medium' | 'small'
    weight?: 'medium' | 'bold'
    text: ReactNode
    articleClassName?: string
}
function BadgeRoundBox({
    color = 'line-green500',
    text,
    size = 'medium',
    weight = 'bold',
    articleClassName,
}: BadgeRoundBoxProps) {
    return (
        <span className={cx('article', `weight-${weight}`, `type-${color}`, `size-${size}`, articleClassName)}>
            {text}
        </span>
    )
}

export default BadgeRoundBox
